// src/CustomMenu.js - PROFESYONEL VERSİYON (Kodların AYNEN korundu, sadece görsel eklendi)
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Home,
  Layers,
  Activity,
  Bell,
  Calendar,
  Users,
  LogOut,
  Settings,
  LayoutDashboard,
  Phone,
  BarChart2,
  MessageSquare,
  QrCode,
  FileText,
 Folder, 
} from "lucide-react";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "./config";

/* ---------- i18n ---------- */
const I18N = {
  tr: {
    home: "Ana sayfa",
    mainCategories: "Ana Kategoriler",
    homepageManagement: "Hakkımızda",
    activities: "Faaliyetler",
    announcements: "Duyurular",
    events: "Etkinlikler",
    contact: "İletişim",
    polls: "Anketler",
    feedback: "Geri Bildirim",
    users: "Kullanıcılar",
    settings: "Ayarlar",
    logout: "Çıkış",
    qrCode: "QR Kod",
    appointments: "Randevular",
    accounting: "Muhasebe",
    digitalSignature: "Dijital İmza",
documents: "Evraklarım", 
  },
  en: {
    home: "Home",
    mainCategories: "Main Categories",
    homepageManagement: "About Us",
    activities: "Activities",
    announcements: "Announcements",
    events: "Events",
    contact: "Contact",
    polls: "Polls",
    feedback: "Feedback",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    qrCode: "QR Code",
    appointments: "Appointments",
    accounting: "Accounting",
    digitalSignature: "Digital Signature",
 documents: "My Documents",
  },
  de: {
    home: "Startseite",
    mainCategories: "Hauptkategorien",
    homepageManagement: "Über uns",
    activities: "Aktivitäten",
    announcements: "Mitteilungen",
    events: "Veranstaltungen",
    contact: "Kontakt",
    polls: "Umfragen",
    feedback: "Rückmeldung",
    users: "Benutzer",
    settings: "Einstellungen",
    logout: "Abmelden",
    qrCode: "QR Code",
    appointments: "Termine",
    accounting: "Buchhaltung",
    digitalSignature: "Digitale Signatur",
 documents: "Meine Dokumente", 
  },
};

const getLang = () => {
  const fromApp = (localStorage.getItem("app_lang") || "").toLowerCase();
  const fromLang = (localStorage.getItem("lang") || "").toLowerCase();
  const nav = ((navigator.language || "tr").slice(0, 2) || "tr").toLowerCase();
  const cand = fromApp || fromLang || nav;
  return ["tr", "en", "de"].includes(cand) ? cand : "tr";
};

const t = (lang, key, fallback) => I18N[lang]?.[key] ?? fallback ?? key;

/* -------- Upload URL normalize -------- */
const ORIGIN = ORIGIN_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const UP_BASE = (UPLOAD_BASE && UPLOAD_BASE.trim()) || "";

function originWithoutPanel(originStr) {
  try {
    const u = new URL(originStr);
    if (u.hostname.startsWith("panel.")) {
      u.hostname = u.hostname.replace(/^panel\./, "");
      return u.origin;
    }
    return u.origin;
  } catch {
    return originStr;
  }
}

function normalizeUploadUrl(raw) {
  if (!raw) return "";
  let u = String(raw).trim();
  u = u.replace(/^http:\/\//i, "https://");
  if (!/^https?:\/\//i.test(u) && !u.startsWith("/")) {
    u = `/uploads/${u}`;
  }
  const strip = (p) => p.replace(/^\/?(upload|uploads)\//i, "").replace(/^\/+/, "");
  try {
    const abs = new URL(u, ORIGIN);
    const filePart = strip(abs.pathname);
    const chosenOrigin = UP_BASE ? new URL(UP_BASE, ORIGIN).origin : originWithoutPanel(ORIGIN);
    const baseUrl = new URL(UP_BASE || "/uploads", chosenOrigin);
    let basePath = baseUrl.pathname.replace(/\/+$/, "");
    if (!/(\/upload(s)?)$/i.test(basePath)) basePath += "/uploads";
    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return u;
  }
}

const bust = (u, v) => (u ? `${u}${u.includes("?") ? "&" : "?"}v=${v}` : "");

/* ---- Kurumsal bilgiler (localStorage) ---- */
const readBrandInfo = (lang) => {
  let nameByLang = {};
  try {
    nameByLang = JSON.parse(localStorage.getItem("app_institution_by_lang") || "{}");
  } catch (_) {}
  const institution = nameByLang?.[lang] || nameByLang?.tr || localStorage.getItem("app_institution_name") || "Muhtar";
  const authorized = localStorage.getItem("app_authorized_name") || "Haymes Tasarım";
  const logo = normalizeUploadUrl(localStorage.getItem("app_logo_url") || "/logo192.png");
  return { institution, authorized, logo };
};

/* ---- Ayarlar endpoint adayları ---- */
const SETTINGS_CANDIDATES = ["kurum-ayarlar", "kurum-ayar", "ayarlar", "settings"];

async function fetchBrandFromAPI(lang) {
  const token = localStorage.getItem("token");
  if (!token) return null;

  const order = [localStorage.getItem("app_settings_ep")].filter(Boolean).concat(SETTINGS_CANDIDATES);

  for (const ep of order) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
      });
      if (!res.ok) continue;

      const json = await res.json().catch(() => ({}));
      const d = json?.data || json || {};
      const nameByLang = {
        tr: d.firma_adi_tr || "",
        en: d.firma_adi_en || "",
        de: d.firma_adi_de || "",
      };
      const institution = nameByLang?.[lang] || nameByLang?.tr || nameByLang?.en || "" || "Muhtar";
      const authorized = d.yetkili_adi || "";
      const logo = normalizeUploadUrl(d.logo_url || d.logo || "");

      localStorage.setItem("app_institution_by_lang", JSON.stringify(nameByLang));
      localStorage.setItem("app_institution_name", institution);
      localStorage.setItem("app_authorized_name", authorized);
      if (logo) localStorage.setItem("app_logo_url", logo);

      window.dispatchEvent(new Event("app_settings_change"));
      localStorage.setItem("app_settings_ep", ep);

      return { institution, authorized, logo };
    } catch {
      // sıradakine devam
    }
  }
  return null;
}

const CustomMenu = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 🆕 Aktif sayfa için eklendi

  // dil & marka bilgileri
  const [lang, setLang] = useState(getLang());
  const [{ institution, authorized, logo }, setBrand] = useState(readBrandInfo(getLang()));

  // Görsel önbellek kırmak için versiyon
  const [ver, setVer] = useState(0);
  const lastTokenRef = useRef(localStorage.getItem("token") || "");
  
  // Modül aktiflik durumları
  const [bookingEnabled, setBookingEnabled] = useState(false);
  const [accountingEnabled, setAccountingEnabled] = useState(false);
  const [digitalSignatureEnabled, setDigitalSignatureEnabled] = useState(false);
  
  // ⭐ Menü yenileme anahtarı
  const [menuKey, setMenuKey] = useState(0);

  // Sunucudan marka çek
  const loadBrand = useCallback(async (reason = "init") => {
    const curToken = localStorage.getItem("token") || "";
    const tokenChanged = curToken !== lastTokenRef.current;
    if (reason === "focus" || tokenChanged || reason === "init") {
      const fromApi = await fetchBrandFromAPI(getLang());
      if (fromApi) {
        setBrand({
          institution: fromApi.institution || institution,
          authorized: fromApi.authorized || authorized,
          logo: fromApi.logo || logo,
        });
        setVer((v) => v + 1);
      } else {
        setBrand(readBrandInfo(getLang()));
        setVer((v) => v + 1);
      }
      lastTokenRef.current = curToken;
    }
  }, [institution, authorized, logo]);

  // 📅 Randevu ayarı
  const loadBookingFlag = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const res = await fetch(`${API_BASE}/randevu/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      setBookingEnabled(data?.data?.randevu_aktif === true);
    } catch (error) {
      console.error("Randevu yüklenirken hata:", error);
    }
  }, []);

  // 🧾 Muhasebe ayarı
  const loadAccountingFlag = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const res = await fetch(`${API_BASE}/accounting/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      setAccountingEnabled(data?.data?.accounting_aktif === true);
    } catch (error) {
      console.error("Muhasebe yüklenirken hata:", error);
    }
  }, []);

  // 📄 Dijital imza ayarı
  const loadDigitalSignatureFlag = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const res = await fetch(`${API_BASE}/dijitalimza/settings`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) return;
      const data = await res.json();
      setDigitalSignatureEnabled(data?.data?.dijital_imza_aktif === true);
      setMenuKey(prev => prev + 1);
    } catch (error) {
      console.error("Dijital imza hatası:", error);
    }
  }, []);

  // Tüm flag'leri yükle
  const loadAllFlags = useCallback(async () => {
    await Promise.all([
      loadBookingFlag(),
      loadAccountingFlag(),
      loadDigitalSignatureFlag()
    ]);
  }, [loadBookingFlag, loadAccountingFlag, loadDigitalSignatureFlag]);

  // Ana useEffect
  useEffect(() => {
    setBrand(readBrandInfo(getLang()));
    setVer((v) => v + 1);
    loadBrand("init");
    loadAllFlags();

    const onLang = () => {
      const l = getLang();
      setLang(l);
      setBrand(readBrandInfo(l));
      setVer((v) => v + 1);
      loadBrand("lang");
    };

    const onSettings = () => {
      setBrand(readBrandInfo(getLang()));
      setVer((v) => v + 1);
      loadAllFlags();
    };

    const onStorage = (e) => {
      if (!e || !e.key) return;
      if (["app_lang", "lang"].includes(e.key)) onLang();
      if (["app_institution_by_lang", "app_institution_name", "app_authorized_name", "app_logo_url"].includes(e.key)) {
        onSettings();
      }
      if (e.key === "token") {
        loadBrand("token");
        loadAllFlags();
      }
    };

    const onFocus = () => {
      loadBrand("focus");
      loadAllFlags();
    };

    window.addEventListener("app_lang_change", onLang);
    window.addEventListener("app_settings_change", onSettings);
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", onFocus);

    return () => {
      window.removeEventListener("app_lang_change", onLang);
      window.removeEventListener("app_settings_change", onSettings);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", onFocus);
    };
  }, [loadBrand, loadAllFlags]);

  const logoSrc = bust(logo || "/logo192.png", ver);

  // 🆕 Aktif sayfa kontrolü
  const isActive = (path) => {
    return location.pathname === path;
  };

  // 🆕 MenuItem bileşeni - Tekrar kullanılabilir
  const MenuItem = ({ path, icon, label, highlight = null }) => {
    const active = isActive(path);
    const highlightColor = {
      orange: 'from-orange-600 to-orange-700',
      green: 'from-green-600 to-green-700',
      purple: 'from-purple-600 to-purple-700'
    }[highlight];

    return (
      <li
        onClick={() => navigate(path)}
        className={`
          flex items-center gap-3 px-4 py-2.5 rounded-lg cursor-pointer
          transition-all duration-200 font-medium
          ${active 
            ? `bg-gradient-to-r ${highlightColor || 'from-blue-600 to-blue-700'} text-white shadow-lg scale-[1.02]` 
            : `hover:bg-gray-700 text-gray-200 hover:text-white ${highlight ? `hover:bg-opacity-30` : ''}`
          }
          ${highlight && !active ? `hover:bg-${highlight}-600/20` : ''}
        `}
      >
        {icon}
        <span>{label}</span>
        {active && (
          <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
        )}
      </li>
    );
  };

  return (
    <div key={menuKey} className="h-screen w-[250px] bg-gradient-to-b from-gray-800 to-gray-900 text-white flex flex-col fixed left-0 top-0 shadow-2xl overflow-y-auto">
      {/* ÜST: Logo + Kurum bilgisi - GELİŞTİRİLDİ */}
      <div className="relative pt-8 pb-6 px-4 bg-gradient-to-r from-gray-900 to-gray-800 border-b border-gray-700">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-purple-500 to-blue-500"></div>
        <div className="flex flex-col items-center">
          <div className="relative">
            <img
              src={logoSrc}
              alt="Logo"
              className="w-20 h-20 rounded-full border-4 border-gray-700 shadow-xl object-cover bg-white"
              onError={(e) => {
                e.currentTarget.src = "/logo192.png";
              }}
            />
            <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-gray-800"></div>
          </div>
          <p className="mt-3 text-lg font-bold truncate max-w-full px-2 text-white">{institution}</p>
          <div className="mt-2 px-4 py-1.5 bg-gray-700/50 rounded-full backdrop-blur-sm border border-gray-600">
            <span className="text-sm font-medium text-gray-300">{authorized}</span>
          </div>
        </div>
      </div>

      {/* ORTA: Menü - GELİŞTİRİLDİ */}
      <div className="flex-1 mt-4 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 px-3">
        <ul className="space-y-1">
          <MenuItem path="/" icon={<Home size={18} />} label={t(lang, "home", "Anasayfa")} />
          <MenuItem path="/anakategoriler" icon={<Layers size={18} />} label={t(lang, "mainCategories", "Ana Kategoriler")} />
          <MenuItem path="/bizkimiz" icon={<LayoutDashboard size={18} />} label={t(lang, "homepageManagement", "Hakkımızda")} />
          <MenuItem path="/faaliyetler" icon={<Activity size={18} />} label={t(lang, "activities", "Faaliyetler")} />
          <MenuItem path="/duyurular" icon={<Bell size={18} />} label={t(lang, "announcements", "Duyurular")} />
          <MenuItem path="/etkinlikler" icon={<Calendar size={18} />} label={t(lang, "events", "Etkinlikler")} />
    <MenuItem path="/evraklarim" icon={<Folder size={18} />} label={t(lang, "documents", "Evraklarım")} highlight="blue" />

          {/* 📅 RANDEVULAR - Dinamik */}
          {bookingEnabled && (
            <MenuItem path="/randevular" icon={<Calendar size={18} />} label={t(lang, "appointments", "Randevular")} highlight="orange" />
          )}

          {/* 🧾 MUHASEBE - Dinamik */}
          {accountingEnabled && (
            <MenuItem path="/muhasebe" icon={<BarChart2 size={18} />} label={t(lang, "accounting", "Muhasebe")} highlight="green" />
          )}

          {/* 📄 DİJİTAL İMZA - Dinamik */}
          {digitalSignatureEnabled && (
            <MenuItem path="/dijital-imza" icon={<FileText size={18} />} label={t(lang, "digitalSignature", "Dijital İmza")} highlight="purple" />
          )}

          <MenuItem path="/iletisim" icon={<Phone size={18} />} label={t(lang, "contact", "İletişim")} />
          <MenuItem path="/anketler" icon={<BarChart2 size={18} />} label={t(lang, "polls", "Anketler")} />
          <MenuItem path={`/geribildirimler?lang=${lang}`} icon={<MessageSquare size={18} />} label={t(lang, "feedback", "Geri Bildirim")} />
          <MenuItem path="/qr-kod" icon={<QrCode size={18} />} label={t(lang, "qrCode", "QR Kod")} highlight="orange" />
          <MenuItem path="/kullanicilar" icon={<Users size={18} />} label={t(lang, "users", "Kullanıcılar")} />
        </ul>
      </div>

      {/* ALT: Ayarlar + Çıkış - GELİŞTİRİLDİ */}
      <div className="p-4 space-y-3 bg-gray-800/90 backdrop-blur-sm border-t border-gray-700">
        <button 
          onClick={() => navigate("/ayarlar")} 
          className={`
            w-full flex items-center justify-center gap-3 py-3 rounded-lg font-semibold
            transition-all duration-200 relative overflow-hidden group
            ${isActive("/ayarlar") 
              ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg' 
              : 'bg-gray-700 hover:bg-gray-600 text-white'}
          `}
        >
          <Settings size={20} />
          <span>{t(lang, "settings", "Ayarlar")}</span>
          {isActive("/ayarlar") && (
            <span className="absolute left-0 top-0 h-full w-1 bg-white"></span>
          )}
        </button>
        
        <button 
          onClick={() => { 
            localStorage.removeItem("token"); 
            localStorage.removeItem("app_institution_by_lang"); 
            localStorage.removeItem("app_institution_name"); 
            localStorage.removeItem("app_authorized_name"); 
            localStorage.removeItem("app_logo_url"); 
            localStorage.removeItem("app_settings_ep"); 
            window.location.reload(); 
          }} 
          className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white py-4 rounded-xl text-[18px] font-bold transition-all duration-200 shadow-lg hover:shadow-red-500/50"
        >
          <LogOut size={24} />
          <span>{t(lang, "logout", "Çıkış")}</span>
        </button>
      </div>
    </div>
  );
};

export default CustomMenu;